import { render, staticRenderFns } from "./ViewOrganizationUserRides.vue?vue&type=template&id=2b2e98b2"
import script from "./ViewOrganizationUserRides.vue?vue&type=script&lang=js"
export * from "./ViewOrganizationUserRides.vue?vue&type=script&lang=js"
import style0 from "./ViewOrganizationUserRides.vue?vue&type=style&index=0&id=2b2e98b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports